import React, {useEffect, useState} from "react";
import { Dialog, DialogContent } from "@mui/material";
import GenericDataGrid from "Admin/components/AdminComponents/GenericDataGrid";
import UpdateProduto from "./UpdateProduto";

function ListProdutos() {
    const [pointer, setPointer] = useState(null)
    const [open, setOpen] = useState(false)
    const [reload, setReload] = useState(false);

    const handleOpen = (id) =>{
        setPointer(id)
        setOpen(true);
    }

    const handleClose = () => {
      setOpen(false);
      setReload(!reload); // Toggle reload state to trigger useEffect
    };

    const fields = [
      { name: 'codigo', label: 'Código' },
      { name: 'nome', label: 'Nome' },
      { 
        name: 'preco_venda', 
        label: 'Valor',
        render: (item) => `R$ ${item.preco_venda}`
      },
      { 
        name: 'estoque_atual', 
        label: 'Estoque',
        render: (item) => item.controla_estoque ? item.estoque_atual : 'N/A'
      },
      { 
          name: 'status', 
          label: 'Status',
          render: (item) => item.status === 0 ? 'Inativo' : 'Ativo'
      }
    ];

    const actions = [
      { label: 'Editar', handler: (item) => handleOpen(item.id) }
    ];

  return (
    <>
    <GenericDataGrid
      title="Listagem de Produtos"
      endpoint="/produtos"
      fields={fields}
      actions={actions}
      filters={['codigo', 'nome', 'tipo']}
    />
      <Dialog 
       open={open && pointer}
       onClose={handleClose}  
       PaperProps={{
        style: {
          width: '70vw',
          height: '80vh',
          maxWidth: 'none', 
          maxHeight: 'none',
          }
        }}
        >
        <DialogContent>
          <UpdateProduto pointer={pointer} />
        </DialogContent>
      </Dialog>
    </>

  );
}

export default ListProdutos;